// jQuery plugins
import './globals/jquery';
import './globals/jquery-plugins';
import 'jquery-trend';
import 'jquery-revealer';

// Helpers
import Newsletter from './helpers/Newsletter';


// Section imports
import Sections from './Sections';
import StaticHeaderReduced from './sections/StaticHeaderReduced';
import StaticGiftCard from './sections/StaticGiftCard';

const sections = new Sections();
sections.register('static-header-reduced', section => new StaticHeaderReduced(section));
sections.register('static-gift-card', section => new StaticGiftCard(section));

new Newsletter();
